import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Spin, Alert } from 'antd';

import DisplayText from '../common/text/DisplayText';

import { getCostcodeByIds } from './state/costcodes.actions';

const MAX_FAIL_COUNT = 3;
export default function CostcodeDisplay({
  costcodeId,
}) {
  const dispatch = useDispatch();
  const costcodeIdMap = useSelector((state) => state.costcodes.costcodeIdMap);
  const costcodeDetails = costcodeIdMap[costcodeId];

  const hasCostcodeDetails = !!costcodeDetails;

  const [loading, setLoading] = useState(false);
  const [lastId, setLastId] = useState(null);
  const [failCount, setFailCount] = useState(0);

  const hasFailed = failCount >= MAX_FAIL_COUNT;

  const getCostcodeDetails = async () => {
    if (costcodeId !== lastId) {
      setLastId(costcodeId);
      setFailCount(0);
    } else if (hasFailed) {
      return;
    }
    if (hasCostcodeDetails) return;
    setLoading(true);
    const passed = await dispatch(getCostcodeByIds([costcodeId]));
    if (passed) {
      setFailCount(0);
    } else {
      setFailCount(failCount + 1);
    }
    setLoading(false);
  };

  if (!costcodeId) return null;
  if (hasFailed && !hasCostcodeDetails) {
    return <Alert message="Failed to load Cost Code" type="error" />;
  }
  if (loading) return <Spin size="small" />;
  if (!hasCostcodeDetails) {
    getCostcodeDetails();
    return null;
  }

  if (hasFailed) {
    setFailCount(0);
  }

  const costcodeName = `${costcodeDetails.code} - ${costcodeDetails.name}`;

  return <DisplayText title={costcodeName} />;
}

CostcodeDisplay.propTypes = {
  costcodeId: PropTypes.string.isRequired,
};
